module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNSAxMSI+PGRlZnM+PHBhdGggaWQ9InB1M3NhIiBkPSJNNTg0LjA0IDgwLjY2di03LjYyaDIuMzZ2Ny42MnoiLz48cGF0aCBpZD0icHUzc2IiIGQ9Ik01ODQuMDQgODEuODJ2LTIuMzZoMTEuNzN2Mi4zNnoiLz48L2RlZnM+PGc+PGcgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDIwOS4xNzQgNzQ1LjAzNikiPjxnPjx1c2UgZmlsbD0iI2ZmZiIgeGxpbms6aHJlZj0iI3B1M3NhIi8+PC9nPjxnPjx1c2UgZmlsbD0iI2ZmZiIgeGxpbms6aHJlZj0iI3B1M3NiIi8+PC9nPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-check.svg
// module id = 63
// module chunks = 0